export default __webpack_public_path__ + "static/media/ic_merchandising_noti.b147cad7.svg";